import { authState } from './reducers/authReducer';
import { idleState } from './reducers/idleReducer';

export const initialState = {
  authState,
  idleState
};
